import _ from 'underscore';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import {
  withSiteMap,
  siteMapPropType,
  processorSet,
  allSiteMap,
} from '@bingads-webui-campaign-react/with-site-map';

const RecommendationSubPageMenu = React.lazy(() => import(/* webpackMode: 'eager' */ './recommendation-sub-page-menu').then(({ StyledRecommendationSubPageMenu }) => ({ default: StyledRecommendationSubPageMenu })));

export const Loader = (props) => {
  const { siteMap, updateAvailability } = props;

  const selectedParent = _.findWhere(siteMap, { selected: true });
  const available = !_.isEmpty(selectedParent)
    && selectedParent.id === 'recommendations';
  useEffect(() => {
    updateAvailability(available);
  });

  return props.isVisible ? (
    <React.Suspense fallback={null}>
      <RecommendationSubPageMenu
        {...props}
        available={available}
      />
    </React.Suspense>
  ) : null;
};

Loader.propTypes = {
  siteMap: siteMapPropType.isRequired,
  isVisible: PropTypes.bool.isRequired,
  updateAvailability: PropTypes.func,
};

Loader.defaultProps = {
  updateAvailability: _.noop,
};

export const RecommendationSubPageMenuLoader = withSiteMap(React.memo(Loader), processorSet.all, allSiteMap, 'recommendations');
